import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { format } from '../../shared/utils/string.util';
import { IColumnMappingTransformation } from 'app/model/dataflow/column-mapping-transformation-utilities';
import { BaseColumnMappingTransformation } from './base-column-mapping-transformation';

@Metamodel.model({
    name: 'select',
    display: [stringResources.DataFlowSelectTransformationLabel, stringResources.DataFlowSelectTransformationsLabel],
    referable: true,
    constraints: {
        name: {
            required: true
        }
    }
})
export class SelectTransformation extends BaseColumnMappingTransformation implements IColumnMappingTransformation {
    public static readonly MODEL: IModel;

    constructor() {
        super();
        this.skipDuplicateMapInputs.expression = 'true';
        this.skipDuplicateMapOutputs.expression = 'true';
    }

    protected getGeneratedDescription(): string {
        if (this.getFirstInputStream()) {
            return this.outputColumns().length > 0 ? format(stringResources.SelectDescription, this.getFirstInputStream().qualifiedName, this.outputStream.qualifiedName,
                this.outputColumns().map((column) => column.name).join(', ')) : stringResources.SelectDescriptionNoColumns;
        }
        return stringResources.SelectDescriptionNoInputStream;
    }
}
